import { render, staticRenderFns } from "./calendar-set.vue?vue&type=template&id=4af5f3a4"
import script from "./calendar-set.vue?vue&type=script&lang=js"
export * from "./calendar-set.vue?vue&type=script&lang=js"
import style0 from "./calendar-set.vue?vue&type=style&index=0&id=4af5f3a4&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports